import { faLessThanEqual } from "@fortawesome/free-solid-svg-icons";
import { Fragment, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import WrappedCsoUpdatePreference from "../../../SupporterSignUp/CSOUpdatePreference";
import WrappedSupporterUpdatePreference from "../../../SupporterSignUp/SupporterUpdatePreference";
import CaretRight from "../../../../Icons/CaretRight";

const DetailBadge = ({ text }) => {
  const [isButton, setIsButton] = useState(false);

  const handleRefCallback = (element) => {
    const buttonParent = element?.closest('div[role="button"]');
    if (buttonParent) {
      setIsButton(true);
    } else {
      setIsButton(false);
    }
  };

  return (
    <div
      ref={handleRefCallback}
      style={{
        backgroundColor: "#44CAE1",
        color: "#fff",
        padding: "6px 17px",
        borderRadius: "5px",
        marginRight: "8px",
        display: "inline-block",
        marginBottom: "8px",
        cursor: isButton ? "pointer" : "default",
      }}
    >
      {text}
    </div>
  );
};

const SupporterTimeline = ({ setActiveKey = () => {} }) => {
  const [modalPreferenceOpen, setModalPreferenceOpen] = useState(false);
  const history = useHistory();
  return (
    <div className="ml-5">
      <div
        style={{
          marginLeft: "-3rem",
        }}
      >
        企業とCSO
        の連携アクションの基本的なプロセスを以下に記載します。各プロセスにおいてSocial
        map のサポート機能も併せてご活用ください。
      </div>
      <VerticalTimeline layout="2-columns">
        <VerticalTimelineElement
          className="vertical-timeline-item"
          icon={<i className="badge badge-dot badge-dot-xl badge-gray"> </i>}
          date="1. 目的・価値"
          dateClassName="text-black-100 -l-lg"
        >
          <h4 className="timeline-title">
            自組織（自社/ 自団体）がCSO と連携する目的・価値を確認します。
          </h4>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span
              style={{
                fontSize: "20px",
                paddingBottom: "12px",
              }}
            >
              <CaretRight />
            </span>
            <div
              role="button"
              style={{
                cursor: "pointer",
                display: "inline-block",
              }}
              onClick={() => {
                setActiveKey("2");
              }}
            >
              <DetailBadge text="連携方針" />
            </div>
          </div>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-item w-100"
          icon={<i className="badge badge-dot badge-dot-xl badge-gray"> </i>}
          date="2.マッチング"
          dateClassName="text-black-100 -l-lg"
        >
          <h4 className="timeline-title">
            様々なCSOを検索、比較し最適なパートナーシップを絞り込みます。
          </h4>
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <span
                style={{
                  fontSize: "20px",
                  paddingBottom: "12px",
                }}
              >
                <CaretRight />
              </span>
              <div
                role="button"
                style={{
                  display: "inline-block",
                }}
                onClick={() => {
                  history.push("/dashboards/journy");
                }}
              >
                <DetailBadge text="Social map" />
              </div>
              <div
                role="button"
                style={{
                  display: "inline-block",
                }}
                onClick={() => {
                  setActiveKey("3");
                }}
              >
                <DetailBadge text="検索" />
              </div>
              <div
                role="button"
                style={{
                  display: "inline-block",
                }}
                onClick={() => {
                  setActiveKey("4");
                }}
              >
                <DetailBadge text="比較分析" />
              </div>
            </div>
          </div>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-item w-100"
          icon={<i className="badge badge-dot badge-dot-xl badge-gray"> </i>}
          date="3.連携構築"
          dateClassName="text-black-100 -l-lg"
        >
          <h4 className="timeline-title">
            特定された連携先候補と面接、連携内容の合意、契約を結びます。
          </h4>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span
              style={{
                fontSize: "20px",
                paddingBottom: "12px",
              }}
            >
              <CaretRight />
            </span>
            <div
              role="button"
              style={{ display: "inline-block" }}
              onClick={() => {
                setActiveKey("5");
              }}
            >
              <DetailBadge text="メッセージ" />
            </div>
          </div>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-item w-100"
          icon={<i className="badge badge-dot badge-dot-xl badge-gray"> </i>}
          date="4.アクション"
          dateClassName="text-black-100 -l-lg"
        >
          <h4 className="timeline-title">
            活動を行いながら対話・学び・関係性の深化を目指します。
          </h4>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span
              style={{
                fontSize: "20px",
                paddingBottom: "12px",
              }}
            >
              <CaretRight />
            </span>
            <div
              role="button"
              style={{ display: "inline-block" }}
              onClick={() => {
                history.push("/dashboards/contact");
              }}
            >
              <DetailBadge text="伴走支援" />
            </div>
          </div>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-item w-100"
          icon={<i className="badge badge-dot badge-dot-xl badge-gray"> </i>}
          date="5.評価・改善"
          dateClassName="text-black-100 -l-lg"
        >
          <h4 className="timeline-title">
            活動を評価・レポートします。そして、連携の進化に向けて前進します。
          </h4>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span
              style={{
                fontSize: "20px",
                paddingBottom: "12px",
              }}
            >
              <CaretRight />
            </span>
            <div
              role="button"
              style={{ display: "inline-block" }}
              onClick={() => {
                history.push("/dashboards/contact");
              }}
            >
              <DetailBadge text="伴走支援" />
            </div>
          </div>
        </VerticalTimelineElement>
      </VerticalTimeline>
      <WrappedSupporterUpdatePreference
        open={modalPreferenceOpen}
        setOpen={() => {
          setModalPreferenceOpen(!modalPreferenceOpen);
        }}
        backToInitialPage={() => {
          setModalPreferenceOpen(!modalPreferenceOpen);
        }}
      />
    </div>
  );
};

const CSOTimeline = ({ setActiveKey = () => {} }) => {
  const [modalPreferenceOpen, setModalPreferenceOpen] = useState(false);
  const history = useHistory();
  return (
    <div
      style={{
        marginLeft: "-20px",
      }}
    >
      <VerticalTimeline layout="2-columns">
        <VerticalTimelineElement
          className="vertical-timeline-item"
          icon={<i className="badge badge-dot badge-dot-xl badge-gray"> </i>}
        >
          <h4 className="timeline-title">1. 目的・価値</h4>
          <p>自組織が連携に取り組む目的を明確にします。</p>
          <div
            role="button"
            onClick={() => {
              setActiveKey("2");
            }}
            style={{
              cursor: "pointer",
              display: "inline-block",
            }}
          >
            <DetailBadge text="連携方針" />
          </div>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-item w-100"
          icon={<i className="badge badge-dot badge-dot-xl badge-gray"> </i>}
        >
          <h4 className="timeline-title">2.マッチング</h4>
          <p>組織情報を充実化させ効果的にPRします。</p>
          <div
            role="button"
            style={{
              display: "inline-block",
            }}
            onClick={() => {
              history.push("/dashboards/plofile-organization/");
            }}
          >
            <DetailBadge text="組織情報" />
          </div>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-item w-100"
          icon={<i className="badge badge-dot badge-dot-xl badge-gray"> </i>}
        >
          <h4 className="timeline-title">3.連携構築</h4>
          <p>特定された連携先候補と面接、連携内容の合意、契約を結びます。</p>
          <div
            role="button"
            onClick={() => {
              setActiveKey("3");
            }}
            style={{
              cursor: "pointer",
              display: "inline-block",
            }}
          >
            <DetailBadge text="メッセージ" />
          </div>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-item w-100"
          icon={<i className="badge badge-dot badge-dot-xl badge-gray"> </i>}
        >
          <h4 className="timeline-title">4.アクション</h4>
          <p>活動を行いながら対話・学び・関係性の深化を目指します。</p>
          <div
            role="button"
            onClick={() => {
              history.push("/dashboards/contact");
            }}
            style={{
              cursor: "pointer",
              display: "inline-block",
            }}
          >
            <DetailBadge text="伴走支援" />
          </div>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-item w-100"
          icon={<i className="badge badge-dot badge-dot-xl badge-gray"> </i>}
        >
          <h4 className="timeline-title">5.評価・改善</h4>
          <p>
            活動を評価・レポートします。そして、連携の進化に向けて前進します。
          </p>
          <div
            role="button"
            onClick={() => {
              history.push("/dashboards/contact");
            }}
            style={{
              cursor: "pointer",
              display: "inline-block",
            }}
          >
            <DetailBadge text="伴走支援" />
          </div>
        </VerticalTimelineElement>
      </VerticalTimeline>
      <WrappedCsoUpdatePreference
        open={modalPreferenceOpen}
        setOpen={() => {
          setModalPreferenceOpen(!modalPreferenceOpen);
        }}
        backToInitialPage={() => {
          setModalPreferenceOpen(!modalPreferenceOpen);
        }}
      />
    </div>
  );
};

const TabGetStarted = ({
  isSupporter = faLessThanEqual,
  setActiveKey = () => {},
  activeKey,
}) => {
  useEffect(() => {
    localStorage.setItem("tabActive", activeKey);
  }, [activeKey]);
  return (
    <Fragment>
      <div
        className="pt-4"
        style={{
          overflowX: "hidden",
        }}
      >
        {isSupporter ? (
          <SupporterTimeline setActiveKey={setActiveKey} />
        ) : (
          <CSOTimeline setActiveKey={setActiveKey} />
        )}
      </div>
    </Fragment>
  );
};

export default TabGetStarted;
